<div class="container">
    <div class="error">
        <app-error-alert [message]="errorMessage" *ngIf="showAlertError"></app-error-alert>
    </div>
    <section class="unlock-users">
        <form class="form-wrapper" #consultEmailsForm="ngForm" (ngSubmit)="onSubmit(consultEmailsForm)">
            <div class="form-inner">
                <div class="form-section">
                    <div class="form-group">
                        <label for="email-input" class="form-label">Correos</label>
                        <textarea id="email-input" class="form-input form-textarea" type="text"
                            placeholder="Ingresa Correos Separados Por ," [(ngModel)]="emailInput" name="emailInput"
                            #emailModel="ngModel" required>
                        </textarea>
                        <div *ngIf="emailModel.invalid && emailModel.touched" class="error-message">
                            <i class="error-icon">&#9888;</i>
                            <span class="error-text">Este campo es requerido!</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-actions">
                <button type="button" class="btn btn-cancel" (click)="cancel(consultEmailsForm)"
                    [ngClass]="{'btn-cancel-valid': consultEmailsForm.valid}">Cancelar</button>
                <button type="submit" class="btn btn-unlock" [ngClass]="{'btn-valid': consultEmailsForm.valid}"
                    [disabled]="consultEmailsForm.invalid">Consultar</button>
            </div>
        </form>
    </section>
</div>

<section class="results-container" *ngIf="crcEmails.length > 0">
    <div class="results-surface">
        <div class="results-content">
            <header class="results-header">
                <h2 class="results-title">Resultados</h2>
                <div class="results-divider">
                    <hr class="results-line">
                </div>
            </header>
            <div class="results-body">
                <div class="results-table">

                    <div class="results-columns-wrapper">
                        <div class="results-column">
                            <div class="results-cell-header"></div>
                            <div class="results-cell" *ngFor="let crcEmail of paginatedEmails; let i = index">
                                <b>{{(pageIndex * pageSize) + i + 1}}</b>
                            </div>
                            <div class="results-cell-empty"></div>
                        </div>
                        <div class="results-column">
                            <div class="results-cell-header">Correo</div>
                            <div class="results-cell" *ngFor=" let crcEmail of paginatedEmails">{{crcEmail.llave}}</div>
                        </div>
                        <div class="results-column">
                            <div class="results-cell-header">Aplicacion</div>
                            <div class="results-cell" *ngFor="let crcEmail of paginatedEmails">
                                {{crcEmail.opcionesContacto.aplicacion}}</div>
                        </div>
                        <div class="results-column">
                            <div class="results-cell-header">Llamada</div>
                            <div class="results-cell" *ngFor="let crcEmail of paginatedEmails">
                                {{crcEmail.opcionesContacto.llamada}}</div>
                            <div class="results-cell-empty"></div>
                        </div>
                        <div class="results-column">
                            <div class="results-cell-header">Sms</div>
                            <div class="results-cell" *ngFor="let crcEmail of paginatedEmails">
                                {{crcEmail.opcionesContacto.sms}}
                            </div>
                            <div class="results-cell-empty"></div>
                        </div>
                    </div>
                </div>
                <app-paginator [totalItems]="crcEmails.length" [initialPageSize]="pageSize"
                    (pageChange)="onPageChange($event)">
                </app-paginator>
            </div>
        </div>
    </div>
</section>